import React, { Component } from "react";
import {
  NavLink,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { deletePageByIdAPI } from "./views/page/pageAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TranslatableText from "../../../../Language/TranslatableText";
import {
  faEdit,
  faInfoCircle,
  faTrash,
  faCloudDownloadAlt,
  faUserNinja
} from "@fortawesome/pro-solid-svg-icons";
import Tippy from "@tippyjs/react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
//import "bootstrap/dist/css/bootstrap.min.css";
import { LanguageContext } from "../../../../contexts/language-context";
import {
  getWizardByIdAPI,
  getWizardPagesListByIdAPI,
  getReportTemplatesOfWizardByIdAPI,
  deleteReportTemplateByIdAPI,
  downloadReportTemplateByIdAPI
} from "./wizardAPI";
import Accent from "../../../../components/accent/Accent";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../../contexts/global-context";
import { InlineLoading } from "../../../../components";


const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;
const NoDataIndication = () => (
  <div className="text-center">
    <span>
      <TranslatableText translationKey="no_data_available" />
    </span>
  </div>
);
const defaultSorted = [
  {
    dataField: "order", // if dataField is not match to any column you defined, it will be ignored.
    order: "asc" // desc or asc
  }
];

class WizardDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableLoader: false,
      name: "",
      pages: [],
      columns: [
        {
          dataField: "id",
          text: "ID",
          sort: true,
          classes: "recordID"
        },
        {
          dataField: "name",
          text: "Name",
          sort: true
        },
        {
          dataField: "condition",
          text: "Condition",
          sort: true
        },
        {
          dataField: "order",
          text: "Order",
          sort: true
        },
        {
          dataField: "actions",
          text: "Actions",
          csvExport: false
        }
      ],
      templates: [],
      templateColumns: [
        {
          dataField: "id",
          text: "ID",
          hidden: true
        },
        {
          dataField: "name",
          text: "Name",
          sort: true
        },
        {
          dataField: "description",
          text: "Description",
          sort: true
        },
        {
          dataField: "language",
          text: "Language",
          sort: true
        },
        {
          dataField: "actions",
          text: "Actions",
          csvExport: false
        }
      ],
      deleteModal: false,
      deleteLoader: false,
      pageId: null,
      deleteTemplateModal: false,
      reportTemplateId: null
    };

    this.downloadReportToast = null;
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      getWizardByIdAPI(this.props.match.params.id)
        .then(res => {
          this.setState({
            name: res.data.name
          });
        })
        .catch(error => {
          toast.error(this.context.languages["api_error"], {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 3000
          });
        });

      if (this.props.match.params.organizationId === undefined) {
        this.populatePageList();
        this.populateReportTemplates();
      }
    }
  }

  populateReportTemplates = () => {
    var self = this;
    this.setState({ tableLoader: true, templates: [] });
    getReportTemplatesOfWizardByIdAPI(this.props.match.params.id)
      .then(res => {
        if (!Array.isArray(res)) {
          console.log("debug: ", res);
          return;
        }
        var data = res.map(function (el) {
          var o = Object.assign({}, el);
          o.actions = (
            <div className="actions">
              <NavLink onClick={e => self.downloadFile(el.id, e)}>
                <Tippy placement="top" content="Download">
                  <span>
                    <FontAwesomeIcon
                      style={{ color: "var(--primary)" }}
                      icon={faCloudDownloadAlt}
                      size="1x"
                    />
                  </span>
                </Tippy>
              </NavLink>
              <NavLink
                tag={Link}
                to={`/admin/wizard/template/update/${self.props.match.params.id}/${el.id}`}
              >
                <Tippy placement="top" content="Update page">
                  <span>
                    <FontAwesomeIcon icon={faEdit} size="1x" />
                  </span>
                </Tippy>
              </NavLink>
              <NavLink onClick={e => self.openDeleteTemplateModal(el.id, e)}>
                <Tippy placement="top" content="Remove">
                  <span>
                    <FontAwesomeIcon
                      style={{ color: "#d84a4a" }}
                      icon={faTrash}
                      size="1x"
                    />
                  </span>
                </Tippy>
              </NavLink>
            </div>
          );
          return o;
        });
        this.setState({
          templates: data,
          language: this.context.language,
          tableLoader: false
        });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
        this.setState({ tableLoader: false });
      });
  };

  populatePageList = () => {
    var self = this;
    this.setState({ tableLoader: true, pages: [] });
    getWizardPagesListByIdAPI(this.props.match.params.id, this.context.language)
      .then(res => {
        if (!Array.isArray(res)) {
          console.log("debug: ", res);
          return;
        }
        var data = res.map(function (el) {
          var o = Object.assign({}, el);
          o.actions = (
            <div className="actions">
              <NavLink tag={Link} to={`/admin/wizard/page/details/${el.id}`}>
                <Tippy placement="top" content="See details">
                  <span>
                    <FontAwesomeIcon icon={faInfoCircle} size="1x" />
                  </span>
                </Tippy>
              </NavLink>
              <NavLink tag={Link} to={`/admin/wizard/page/update/${el.id}`}>
                <Tippy placement="top" content="Update page">
                  <span>
                    <FontAwesomeIcon icon={faEdit} size="1x" />
                  </span>
                </Tippy>
              </NavLink>
              <NavLink onClick={e => self.openDeleteModal(el.id, e)}>
                <Tippy placement="top" content="Remove">
                  <span>
                    <FontAwesomeIcon
                      style={{ color: "#d84a4a" }}
                      icon={faTrash}
                      size="1x"
                    />
                  </span>
                </Tippy>
              </NavLink>
            </div>
          );
          return o;
        });
        this.setState({
          pages: data,
          language: this.context.language,
          tableLoader: false
        });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
        this.setState({ tableLoader: false });
      });
  };

  toggleDeletePopup = () => {
    this.setState(
      prevState => ({
        deleteModal: !prevState.deleteModal
      }),
      () => {
        if (this.state.deleteModal === false) {
          this.setState({
            pageId: null
          });
          console.log("After Modal Dismissal", this.state.deleteModal);
        }
      }
    );
  };

  openDeleteModal = id => {
    this.setState({
      deleteModal: true,
      pageId: id
    });
  };

  deletePage = id => {
    this.setState({ deleteLoader: true });
    deletePageByIdAPI(id)
      .then(res => {
        this.populatePageList();
        this.setState({
          deleteModal: false,
          deleteLoader: false,
          pageId: null
        });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
        this.setState({
          deleteModal: false,
          deleteLoader: false,
          pageId: null
        });
      });
  };

  toggleDeleteTemplatePopup = () => {
    this.setState(
      prevState => ({
        deleteTemplateModal: !prevState.deleteTemplateModal
      }),
      () => {
        if (this.state.deleteTemplateModal === false) {
          this.setState({
            reportTemplateId: null
          });
          console.log("After Modal Dismissal", this.state.deleteTemplateModal);
        }
      }
    );
  };

  openDeleteTemplateModal = id => {
    this.setState({
      deleteTemplateModal: true,
      reportTemplateId: id
    });
  };

  deleteReportTemplate = id => {
    this.setState({ deleteLoader: true });
    deleteReportTemplateByIdAPI(id, this.context.user.organizations.userId)
      .then(res => {
        this.populateReportTemplates();
        this.setState({
          deleteTemplateModal: false,
          deleteLoader: false,
          reportTemplateId: null
        });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
        this.setState({
          deleteTemplateModal: false,
          deleteLoader: false,
          reportTemplateId: null
        });
      });
  };

  downloadFile = id => {
    this.downloadReportToast = toast.info(
      "Downloading report, please wait...",
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false
      }
    );
    downloadReportTemplateByIdAPI(id)
      .then(res => {
        toast.dismiss(this.downloadReportToast);
        var response = res.data;
        const url = window.URL.createObjectURL(
          new Blob([response], { type: res.headers["content-type"] })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", id); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(error => {
        toast.dismiss(this.downloadReportToast);
        toast.error(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
      });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    let { tableLoader } = this.state;
    return (
      <div className="user-details-view">
        {this.props.match.params.organizationId === undefined ? (
          <section>
            <Row>
              <Col md={12}>
                {this.state.name !== "" ? (
                  <Accent useIcon={false}>
                    <TranslatableText translationKey="list_of_pages_in" /> "
                    {this.state.name}"
                  </Accent>
                ) : (
                  <Accent useIcon={false}>
                    <InlineLoading />
                  </Accent>
                )}
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="table-container">
                  <ToolkitProvider
                    keyField="id"
                    data={this.state.pages}
                    columns={this.state.columns}
                    search
                    exportCSV={{
                      fileName: "data.csv",
                      separator: this.context.user.language === 'dk' ? ';' : ',',
                      ignoreHeader: false,
                      noAutoBOM: false
                    }}
                  >
                    {props => (
                      <div>
                        <div className="flex space-between">
                          <div>
                            <SearchBar {...props.searchProps} />
                          </div>
                          <div>
                            <div className="flex space-between">
                              {this.context.userRoles.find(r =>
                                r.includes("Developer")
                              ) !== undefined ? (
                                <ExportCSVButton
                                  className="export-btn"
                                  {...props.csvProps}
                                >
                                  <FontAwesomeIcon icon={faUserNinja} size="1x" />&nbsp;CSV</ExportCSVButton>
                              ) : (
                                <></>
                              )}
                              <div>
                                <NavLink
                                  className="button-primary"
                                  tag={Link}
                                  to={`/admin/wizard/page/create/${this.props.match.params.id}`}
                                >
                                  <TranslatableText translationKey="create" />
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <BootstrapTable
                          noDataIndication={() =>
                            tableLoader ? (
                              <InlineLoading />
                            ) : (
                              <NoDataIndication />
                            )
                          }
                          {...props.baseProps}
                          pagination={paginationFactory()}
                          defaultSorted={defaultSorted}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </Col>
            </Row>
          </section>
        ) : (
          ""
        )}

        <Row>
          <Col md={12}>
            <Accent useIcon={false}>
              <TranslatableText translationKey="report_templates" />
            </Accent>
          </Col>
          <Col md={12}>
            <div className="table-container">
              <ToolkitProvider
                keyField="id"
                data={this.state.templates}
                columns={this.state.templateColumns}
                search
                exportCSV={{
                  fileName: "data.csv",
                  separator: this.context.user.language === 'dk' ? ';' : ',',
                  ignoreHeader: false,
                  noAutoBOM: false
                }}
              >
                {props => (
                  <div>
                    <div className="flex space-between">
                      <div>
                        <SearchBar {...props.searchProps} />
                      </div>
                      <div>
                        <div className="flex space-between">
                          {this.context.userRoles.find(r =>
                            r.includes("Developer")
                          ) !== undefined ? (
                            <ExportCSVButton
                              className="export-btn"
                              {...props.csvProps}
                            >
                              <FontAwesomeIcon icon={faUserNinja} size="1x" />&nbsp;CSV</ExportCSVButton>
                          ) : (
                            <></>
                          )}
                          <div>
                            <NavLink
                              className="button-primary"
                              tag={Link}
                              to={`/admin/wizard/template/create/${this.props.match.params.id}`}
                            >
                              <TranslatableText translationKey="create" />
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <BootstrapTable
                      noDataIndication={() =>
                        tableLoader ? (
                          <InlineLoading />
                        ) : (
                          <NoDataIndication />
                        )
                      }
                      {...props.baseProps}
                      pagination={paginationFactory()}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Button onClick={this.goBack}>
              {" "}
              <TranslatableText translationKey="back" />
            </Button>
          </Col>
        </Row>
        <div>
          <Modal
            isOpen={this.state.deleteModal}
            toggle={this.toggleDeletePopup}
            className={this.props.className}
          >
            <ModalHeader toggle={this.toggleDeletePopup}>
              Confirm Delete?
            </ModalHeader>
            <ModalBody>
              <Row form>
                <Col md={12}>
                  <p>
                    {" "}
                    <TranslatableText translationKey="confirm_delete_page" />
                  </p>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              {this.state.deleteLoader === false ? (
                <Button
                  outline
                  className="redOutline"
                  onClick={e => this.deletePage(this.state.pageId, e)}
                >
                  <TranslatableText translationKey="delete" />
                </Button>
              ) : (
                <InlineLoading />
              )}{" "}
              <Button outline onClick={this.toggleDeletePopup}>
                <TranslatableText translationKey="cancel" />
              </Button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={this.state.deleteTemplateModal}
            toggle={this.toggleDeleteTemplatePopup}
            className={this.props.className}
          >
            <ModalHeader toggle={this.toggleDeleteTemplatePopup}>
              <TranslatableText translationKey="confirm_delete" />?
            </ModalHeader>
            <ModalBody>
              <Row form>
                <Col md={12}>
                  <p>
                    {" "}
                    <TranslatableText translationKey="company.confirm_delete_template" />
                  </p>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              {this.state.deleteLoader === false ? (
                <Button
                  outline
                  className="redOutline"
                  onClick={e =>
                    this.deleteReportTemplate(this.state.reportTemplateId, e)
                  }
                >
                  <TranslatableText translationKey="delete" />
                </Button>
              ) : (
                <InlineLoading />
              )}{" "}
              <Button outline onClick={this.toggleDeleteTemplatePopup}>
                <TranslatableText translationKey="cancel" />
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }
}

export default withRouter(WizardDetails);
WizardDetails.contextType = GlobalContext;